import React from 'react';
import PropTypes from 'prop-types';

import Image from 'marketing-website/components/modules/Image';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';

import assets from 'marketing-website/configs/pages/features/prototyping/assets.js';

export default function UserTestingArtwork({ color, patternColor }) {
  return (
    <MediaMultipleImages
      fallbackImageSrc={assets.userTestingFallback.src}
      fallbackImageAlt={assets.userTestingFallback.alt}
      fallbackImageMaxWidth={assets.userTestingFallback.maxWidth}
    >
      <Shape type="rectangle" color={color} width={425} height={280} />
      <ParallaxWrapper>
        <Pattern
          color={patternColor}
          type="shortRectangle"
          top="40%"
          left="auto"
          right="20%"
        />
      </ParallaxWrapper>
      <ParallaxWrapper speed={0.5}>
        <Image
          {...assets.mapBundle}
          hasShadow={false}
          position="absolute"
          top="16%"
          left="14%"
        />
      </ParallaxWrapper>
      <ParallaxWrapper speed={1}>
        <Image
          {...assets.avatar}
          hasShadow={false}
          position="absolute"
          top="18%"
          left="64%"
        />
      </ParallaxWrapper>
    </MediaMultipleImages>
  );
}

UserTestingArtwork.propTypes = {
  patternColor: PropTypes.string,
  color: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/UserTestingArtwork/index.js